import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component({
  components: {
    PatientsResultsTabs: () => import('@/components/patients/results/PatientsResultsTabs.vue'),
  },
})
export default class MixinResults extends Vue {
  @Prop({ required: true }) protected patient!: TPatient;
  @Prop({ required: true }) protected acquisition!: TAcquisition;
  @Prop({ required: false }) protected compareAcquisition!: TAcquisition;
  @Prop({ default: null }) protected isSelected!: boolean | null;
}
